import { defineStore } from 'pinia'

export const useWaylineState = defineStore('waylineState', {
  state: () => ({
    wayline: {},
    user_name: '',
    deleteId: null,
    filename: '',
    isEditMode: false,
    editWaylineData: null
  }),
  actions: {
    setWayline (wayLine) {
      this.wayline = wayLine
    },
    setUserName (name) {
      this.user_name = name
    },
    setEditMode (isEdit) {
      this.isEditMode = isEdit
    },
    setEditWaylineData (data) {
      this.editWaylineData = data
    },
    clearEditMode () {
      this.isEditMode = false
      this.editWaylineData = null
    }
  }
})
